import { cn } from "@/lib/utils";
import React, { useEffect, useState } from "react";
import DomesticFlightListItem from "../../components/Domestic/DomesticFlightListItem";
import { useMediaQuery } from "@/hooks/use-media-query";
import { MdFlightLand, MdFlightTakeoff, MdSwapHoriz } from "react-icons/md";
import { Button } from "@/components/ui/button";
import { Tabs } from "@radix-ui/react-tabs";
import { TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import _ from "lodash";
import { isEmptyObj } from "@/src/helpers/commonHelper";
import { useDispatch, useSelector } from "react-redux";
import FlightsSearchForm from "@/src/components/search/FlightsSearchForm";
import FlightListingSkeleton from "@/src/skeletons/flightListSkeleton";
import moment from "moment";
import DomesticFlightFilter from "@/src/components/Domestic/DomesticFlightFilter";
import { HiMiniXMark } from "react-icons/hi2";
import { ReserveFlight } from "@/src/actions/domestic/domesticFlightAction";
import { useNavigate } from "react-router-dom";
import { holdHoldedFlightItem } from "@/src/actions/flightAction";
import Loading from "@/src/common/Loading";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import Login from "../Login";
import { useAuth } from "@/src/provider/AuthProvider";
import useSEO from "../../hooks/useSEO";

const DomesticFlightListing = () => {
  const { flightList, searchForm, isFlightSearching } = useSelector(
    (state) => state.flights
  );
  const { token } = useAuth();
  const [isHolding, setIsHolding] = useState(false);
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const navigate = useNavigate();
  const { setSEO } = useSEO();

  React.useEffect(() => {
    const origin = searchForm?.from || searchForm?.origin;
    const dest = searchForm?.to || searchForm?.destination;
    const departureDate = searchForm?.departure || searchForm?.departureDate;

    if (origin && dest) {
      const dateStr = moment(departureDate).format("M/D");
      setSEO(`Flight Results: ${origin} to ${dest}, ${dateStr} | Yatra Tickets`);
    } else {
      setSEO(`Flight Results | Yatra Tickets`);
    }
  }, [searchForm, setSEO]);
  const [flightResonse, setFlightResponse] = useState({});
  const [filteredList, setFilteredList] = useState([]);
  const [selectedOutboundFlight, setSelectedOutboundFlight] = useState({});
  const [selectedInboundFlight, setSelectedInboundFlight] = useState({});
  const [showBookInfo, setShowBookInfo] = useState(false);
  const [isTwoWay, setIsTwoWay] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [showLoginForm, setShowLoginForm] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    if (
      !isEmptyObj(selectedOutboundFlight) &&
      !isEmptyObj(selectedInboundFlight)
    ) {
      setShowBookInfo(true);
    } else setShowBookInfo(false);
  }, [selectedInboundFlight, selectedOutboundFlight]);
  useEffect(() => {
    if (flightList) {
      if (
        flightList?.InboundFlights?.length > 0 &&
        flightList?.OutboundFlights?.length > 0
      ) {
        setIsTwoWay(true);
      } else {
        setIsTwoWay(false);
      }
      setFlightResponse(flightList);
    }
  }, [flightList]);
  useEffect(() => {
    if (!isTwoWay && !isEmptyObj(selectedOutboundFlight)) {
      handleBook(selectedOutboundFlight)
    }
  }, [selectedOutboundFlight])
  const handleBook = () => {
    if (!token) {
      setShowLoginForm(true);
    }
    else {
      dispatch(holdHoldedFlightItem(selectedOutboundFlight, selectedInboundFlight));
      // Booking logic is here
      // You can use the flight details from flightResonse to book the flight
      // Once booking is successful, navigate to the passenger details form.

      // payload for holding the current flight
      const payload = {
        Adult: selectedOutboundFlight.AdultNo,
        Child: selectedOutboundFlight.ChildNo,
        Origin: searchForm.from, // Assuming the IATA code for Kathmandu
        Destination: searchForm.to, // Assuming the IATA code for Bhairahawa
        Nationality: searchForm.nationality,
        BookParam: {
          AirlineCode: selectedOutboundFlight.AirlineCode,
          CabinClass: selectedOutboundFlight.FlightClassCode,
          BookingClass: selectedOutboundFlight.FlightClassCode,
          Origin: searchForm.from,
          Destination: searchForm.to,
          Nationality: searchForm.nationality,
          DepartureDate: moment(selectedOutboundFlight.DepartureDate).format("DD/MM/YYYY"),
          ArrivalDate: moment(selectedOutboundFlight.ArrivalDate).format("DD/MM/YYYY"),
          TripType: !isEmptyObj(selectedInboundFlight) ? "roundtrip" : "oneway",
          TripStartDate: moment(selectedOutboundFlight.DepartureDate).format("MM/DD/YYYY"),
        },
        DomesticFlightInfos: [
          {
            FlightID: selectedOutboundFlight.FlightID,
            FareID: selectedOutboundFlight.FareID,
            IsInbound: true,
            Supplier: selectedOutboundFlight.Supplier.toString(),
            BookingParam: {
              AirlineCode: selectedOutboundFlight.AirlineCode,
              CabinClass: selectedOutboundFlight.FlightClassCode,
              BaseFare: selectedOutboundFlight.TotalBaseFare,
            },

          },
        ],
      };
      if (typeof (selectedInboundFlight.FlightID) != 'undefined') {
        payload.DomesticFlightInfos.push({
          FlightID: selectedInboundFlight.FlightID,
          FareID: selectedInboundFlight.FareID,
          IsInbound: false,
          Supplier: selectedInboundFlight.Supplier.toString(),
          BookingParam: {
            AirlineCode: selectedInboundFlight.AirlineCode,
            CabinClass: selectedInboundFlight.FlightClassCode,
            BaseFare: selectedInboundFlight.TotalBaseFare,
          },

        })
      }
      setIsHolding(true);
      dispatch(
        ReserveFlight(payload, (response) => {
          setIsHolding(false);
          navigate("/paxinfo");
        })
      );
      // this is for two way flight payloads
      // if (isTwoWay) {
      //   var nextInfo = new Object({ "FlightID": flight, "IsInbound": true, "Supplier": currFlight.Supplier.toString() });
      //   payload.DomesticFlightInfos.push(nextInfo)
      // }
      // console.log("payload: " + currFlight);

      // setShowBookInfo(false);
      // navigate('/book');
    }
  };
  return (
    isHolding ? <Loading /> : <>
      <FlightsSearchForm />
      <Dialog
        open={showLoginForm}
        onOpenChange={setShowLoginForm}
      >
        <DialogContent>
          <Login
            fromLogin
            handleClose={(resp) => {
              setShowLoginForm(false)
            }}
          />

          {/* <DialogFooter>
          <Button type="submit">Save changes</Button>
        </DialogFooter> */}
        </DialogContent>
      </Dialog>
      {isFlightSearching ? (
        <div className="flex justify-center pt-3">
          <FlightListingSkeleton tripTypeID={searchForm.tripType} />
        </div>
      ) : (
        <>
          {" "}
          <div className="container mx-auto px-3">
            <div className="grid lg:grid-cols-4 grid-cols-1 lg:gap-4">
              <div
                className={cn(
                  "hidden fixed lg:sticky top-0 left-0 z-50 w-full h-full lg:left-auto lg:top-0 lg:z-0 lg:w-auto lg:h-auto col-span-1 lg:block",
                  isDesktop && "my-4",
                  false && "block"
                )}
              >
                <div
                  className="h-dvh 
                    lg:h-[calc(100dvh-160px)]
                     flex flex-col 
                     justify-between 
                    bg-background lg:p-4 
                    sticky rounded lg:top-20 lg:overflow-y-auto"
                >
                  {Object.keys(flightResonse).length > 0 && (
                    <DomesticFlightFilter
                      flightResonse={flightResonse}
                      filteredFlightCallback={setFilteredList}
                    />
                  )}

                  <div className="flex lg:hidden items-center justify-between shadow border-b p-3">
                    <h3 className="font-medium text-xl flex-1">
                      Filter Flights
                    </h3>
                    <Button
                      variant="ghost"
                      size="icon"
                      className="rounded-full"
                      onClick={() => {
                        setShowFilter(false);
                      }}
                    >
                      <HiMiniXMark className="h-5 w-5" />
                    </Button>
                  </div>
                </div>
              </div>
              {isDesktop ? (
                <div className="col-span-3">
                  <div
                    className={cn(
                      "grid grid-cols-1 lg:gap-4 py-4",
                      isTwoWay && "lg:grid-cols-2"
                    )}
                  >
                    {/* DEPART LIST */}
                    <div className="grid-cols-1">
                      {isTwoWay && (
                        <div className="py-2 px-4 text-center flex justify-center mb-2 items-center rounded bg-background sticky top-2 text-primary border shadow-primary">
                          <MdFlightTakeoff className="me-2" />
                          <span>DEPART</span>
                        </div>
                      )}
                      {filteredList &&
                        filteredList.OutboundFlights &&
                        filteredList.OutboundFlights.length > 0 &&
                        filteredList.OutboundFlights.map((flight) => {
                          return (
                            <DomesticFlightListItem
                              key={
                                flight.FareID +
                                "flight_" +
                                flight.FlightID +
                                "_id_ob"
                              }
                              flight={flight}
                              IsHolding={(holding) => setIsHolding(holding)}
                              setSelectedFlightCallback={(flight) => {
                                setSelectedOutboundFlight(flight);
                              }}
                              isSelected={
                                isTwoWay &&
                                _.isEqual(selectedOutboundFlight, flight)
                              }
                              isOutbount={true}
                              isTwoWay={isTwoWay}
                              handleBookNowClickCallback={(flight) => {
                                setSelectedOutboundFlight(flight);
                              }}
                            />
                          );
                        })}
                    </div>

                    {/* RETURN LIST */}
                    {filteredList.InboundFlights &&
                      filteredList.InboundFlights.length > 0 && (
                        <div className="grid-cols-1">
                          <div className="py-2 px-4 text-center flex justify-center mb-2 items-center rounded bg-background sticky top-2 text-primary border shadow-primary">
                            <MdFlightLand className="me-2" />
                            <span>RETURN</span>
                          </div>

                          {filteredList.InboundFlights.map((flight) => {
                            return (
                              <DomesticFlightListItem
                                key={
                                  flight.FareID +
                                  "flight_" +
                                  flight.FlightID +
                                  "_id_ib"
                                }
                                flight={flight}
                                IsHolding={(holding) => setIsHolding(holding)}
                                setSelectedFlightCallback={(flight) => {
                                  setSelectedInboundFlight(flight);
                                }}
                                isSelected={
                                  isTwoWay &&
                                  _.isEqual(selectedInboundFlight, flight)
                                }
                                isOutbount={false}
                                isTwoWay={isTwoWay}
                              />
                            );
                          })}
                        </div>
                      )}
                  </div>
                </div>
              ) : (
                <Tabs defaultValue="departure">
                  {isTwoWay && (
                    <TabsList className="grid w-full grid-cols-2 sticky top-2 p-2 h-auto border-gray-200 mt-2 bg-primary text-white">
                      <TabsTrigger value="departure">Departure</TabsTrigger>
                      <TabsTrigger value="return">Return</TabsTrigger>
                    </TabsList>
                  )}
                  <TabsContent value="departure">
                    {filteredList.OutboundFlights &&
                      filteredList.OutboundFlights.length > 0 &&
                      filteredList.OutboundFlights.map((flight) => {
                        return (
                          <DomesticFlightListItem
                            key={
                              flight.FareID +
                              "flight_" +
                              flight.FlightID +
                              "_id"
                            }
                            flight={flight}
                            IsHolding={(holding) => setIsHolding(holding)}
                            setSelectedFlightCallback={(flight) => {
                              setSelectedOutboundFlight(flight);
                            }}
                            isSelected={
                              isTwoWay &&
                              _.isEqual(selectedOutboundFlight, flight)
                            }
                            isOutbount={true}
                            isTwoWay={isTwoWay}
                          />
                        );
                      })}
                  </TabsContent>
                  <TabsContent value="return">
                    {filteredList.InboundFlights &&
                      filteredList.InboundFlights.length > 0 &&
                      filteredList.InboundFlights.map((flight) => {
                        return (
                          <DomesticFlightListItem
                            key={
                              flight.FareID +
                              "flight_" +
                              flight.FlightID +
                              "_id"
                            }
                            flight={flight}
                            IsHolding={(holding) => setIsHolding(holding)}
                            setSelectedFlightCallback={(flight) => {
                              setSelectedInboundFlight(flight);
                            }}
                            isSelected={
                              isTwoWay &&
                              _.isEqual(selectedInboundFlight, flight)
                            }
                            isOutbount={false}
                            isTwoWay={isTwoWay}
                          />
                        );
                      })}
                  </TabsContent>
                </Tabs>
              )}
            </div>
          </div>
          {showBookInfo && (
            <div className="fixed bottom-0 w-full bg-background  shadow-2xl shadow-black border-t py-2">
              <div className="container mx-auto px-4">
                <div className="flex md:items-center flex-col md:flex-row text-sm gap-x-1">
                  <div className="flex-1 flex flex-col sm:flex-row">
                    <div className="flex gap-2 me-4">
                      <img
                        src={selectedOutboundFlight.AirlineLogo}
                        className="w-8 h-8 md:w-16 md:h-16 object-cover border rounded"
                      />
                      <img
                        src={selectedInboundFlight.AirlineLogo}
                        className="w-8 h-8 md:w-16 md:h-16 object-cover border rounded"
                      />
                    </div>
                    <div className="flex-1 py-2 sm:p-0">
                      <h1 className="md:text-lg font-semibold">
                        {selectedOutboundFlight.Origin +
                          " - " +
                          selectedOutboundFlight.Destination}
                      </h1>
                      <div className="flex items-center">
                        <MdFlightTakeoff className="me-2" />
                        <span className="flex-1">
                          Departure: {moment(searchForm.departure).format("ll")}{" "}
                          {selectedOutboundFlight.DepartureTime}
                        </span>
                      </div>
                      <div className="flex items-center">
                        <MdFlightLand className="me-2" />
                        <span className="flex-1">
                          Return: {moment(searchForm.return).format("ll")}{" "}
                          {selectedInboundFlight.DepartureTime}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="border-t md:border-t-0 md:border-l md:ps-4 pt-2 md:pt-0 flex justify-between items-center  border-dotted">
                    <span className="text-xl font-semibold me-3">
                      <span className="text-sm">{selectedOutboundFlight.Currency} </span>
                      {selectedOutboundFlight.TotalFare +
                        selectedInboundFlight.TotalFare}
                    </span>
                    <Button onClick={() => handleBook()}>Book Now</Button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default DomesticFlightListing;
